import { object, ref, string } from "yup";
import { codeValidatiion, emailValidation, passwordValidation } from ".";

export const signupSchema = object().shape({
  userFullName: string().required("Full Name is required"),
  userEmail: emailValidation("Email"),
  userPassword: string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
  confirmPassword: string()
    .oneOf([ref("userPassword")], "Passwords must match")
    .required("Confirm Password is required"),
});

export const loginSchema = object().shape({
  userEmail: emailValidation("Email"),
  userPassword: string().required("Password is required"),
});

export const forgotPasswordSchema = object().shape({
  userEmail: emailValidation("Email"),
});

export const codeSchema = object().shape({
  otp: codeValidatiion("OTP"),
});

export const otpSchema = object().shape({
  otp: codeValidatiion("code"),
});

export const resetPasswordSchema = object().shape({
  otp: codeValidatiion("OTP"),
  userPassword: string().required("Password is required"),
});

export const createNewPasswordSchema = object().shape({
  password: passwordValidation(),
  confirm_password: string()
    .test(
      "password-match",
      "Password and Confirm Password must match",
      function (value?: string) {
        return this.parent.password === value;
      }
    )
    .required("Confirm Password is required"),
});
